import {Component, OnInit} from '@angular/core';
import {ActivationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'dmp-layout-pop-up',
    templateUrl: './layout-pop-up.component.html',
    styleUrls: [
        './layout-pop-up.component.scss',
        '../layout.component.scss'
    ],
    standalone: false
})
export class LayoutPopUpComponent implements OnInit {

    currentYear = new Date().getFullYear();
    public title: string;
    height: string;
  constructor(
      private router: Router,
      private translate: TranslateService) {
      this.router.events.subscribe((event) => {
          if (event instanceof ActivationEnd) {
              if (event.snapshot.data.title) {
                  this.translate.get('title.' + event.snapshot.data.title).subscribe(res =>
                      this.title = res
                  );
              }
          }
      });
  }

  ngOnInit(): void {
      this.height = `${window.innerHeight - 80}px`;
  }
}
